import { InjectionToken } from "@angular/core";
import { FolderOperationService } from "src/app/api/services/folder-operation.service";
import { Presentation } from "src/app/api/services/presentation";
import { FolderService } from "src/app/shared/services/folder.service";
import { EditorService } from "../services/editor.service";

export const providePresentationFolderOperationService = () => ({
  provide: PRESENTATION_FOLDER_OPERATION_SERVICE,
  useFactory: (folderService: FolderService, editorService: EditorService) => {
    return new FolderOperationService(folderService, editorService);
  },
  deps: [FolderService, 'HasFolderStructure']
});

export const PRESENTATION_FOLDER_OPERATION_SERVICE = new InjectionToken<FolderOperationService<Presentation>>(
  'PRESENTATION_FOLDER_OPERATION_SERVICE'
);
